import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AccountingComponent } from './component/accounting/accounting.component';

const routes: Routes = [
  {
    path: 'form/:sampletype/:id',
    component: AccountingComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AccountingRoutingModule { }
